const LOCAL_HISTORY_PREFIX = 'mickoc.localGameHistory.';
const MAX_LOCAL_HISTORY_ITEMS = 50;

function decodeTokenPayload(token) {
  try {
    const encodedPayload = token?.split?.('.')[1];
    if (!encodedPayload) return {};
    const normalized = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
    return JSON.parse(window.atob(padded));
  } catch (_err) {
    return {};
  }
}

export function getHistoryStorageKey(token = localStorage.getItem('token')) {
  const claims = decodeTokenPayload(token);
  return `${LOCAL_HISTORY_PREFIX}${claims.teamId || claims.teamName || claims.schoolName || 'default'}`;
}

export function normalizeHistoryItems(items) {
  const seen = new Set();

  return (Array.isArray(items) ? items : [])
    .filter(Boolean)
    .filter((item) => {
      const key = `${item.timestamp || ''}-${item.situation || ''}-${item.run || ''}-${item.pass || ''}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort((a, b) => Number(b.timestamp || 0) - Number(a.timestamp || 0));
}

export function loadLocalHistory(token) {
  try {
    const rawHistory = localStorage.getItem(getHistoryStorageKey(token));
    if (!rawHistory) return [];
    const parsedHistory = JSON.parse(rawHistory);
    return normalizeHistoryItems(parsedHistory).slice(0, MAX_LOCAL_HISTORY_ITEMS);
  } catch (_err) {
    return [];
  }
}

export function saveLocalHistory(items, token) {
  const nextItems = normalizeHistoryItems(items).slice(0, MAX_LOCAL_HISTORY_ITEMS);
  localStorage.setItem(getHistoryStorageKey(token), JSON.stringify(nextItems));
  return nextItems;
}

export function addLocalHistoryItem(item, token) {
  const currentItems = loadLocalHistory(token);
  return saveLocalHistory([item, ...currentItems], token);
}
